import {observer} from "mobx-react";
import {VehicleDocumentsWidget, CustomerWidget} from "../../../widgets";

interface FmsCreateTopperProps {
    vin: string | undefined
    customerId: string | undefined
}

const FmsCreateTopper = observer(function FmsCreateTopper({
    vin,
    customerId
                                                          }: FmsCreateTopperProps) {
    return <>
        <div className={"columns"}>
            <div className={"column is-half"} style={{display: 'flex', flex: '1'}}>
                <CustomerWidget customerId={customerId} />
            </div>
            <div className={"column is-half"} style={{display: 'flex', flex: '1'}}>
                <VehicleDocumentsWidget customerId={customerId} vin={vin} />
            </div>
        </div>
    </>
})
export {
    FmsCreateTopper
}
